import React from 'react';
import {StyleSheet, View} from 'react-native';
import {colors} from 'src/assets';
import {TabItem, Tab} from './TabItem';

export type TabControlProps = {
  selectedIndex?: number;
  tabs: Tab[];
  onChange?: (index: number) => void;
};

export const TabControl: React.FC<TabControlProps> = ({
  selectedIndex,
  tabs,
  onChange,
}) => {
  return (
    <View style={styles.container}>
      {tabs.map((tab, index) => (
        <TabItem
          key={index}
          label={tab.label}
          selected={index === selectedIndex}
          onPress={() => (onChange ? onChange(index) : {})}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    backgroundColor: colors.white,
  },
});
